import api from './api';

// Routed through the shared api instance so the API host and the auth token
// stay in one place - this file used to carry its own localhost fallback.
const getSettings = async (doctorId) => {
    const response = await api.get(`/settings/${doctorId}`);
    return response.data;
};

const updateSettings = async (doctorId, data) => {
    const response = await api.put(`/settings/${doctorId}`, data);
    return response.data;
};

const uploadSignature = async (doctorId, file) => {
    const formData = new FormData();
    formData.append('signature', file);

    const response = await api.post(`/settings/${doctorId}/signature`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
    return response.data;
};

const uploadWatermark = async (doctorId, file) => {
    const formData = new FormData();
    formData.append('watermark', file);

    const response = await api.post(`/settings/${doctorId}/watermark`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
    return response.data;
};

const removeWatermark = async (doctorId) => {
    const response = await api.delete(`/settings/${doctorId}/watermark`);
    return response.data;
};

const uploadLogo = async (doctorId, file) => {
    const formData = new FormData();
    formData.append('logo', file);

    const response = await api.post(`/settings/${doctorId}/logo`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
    return response.data;
};

const settingsService = {
    getSettings,
    updateSettings,
    uploadSignature,
    uploadLogo,
    uploadWatermark,
    removeWatermark
};

export default settingsService;
